import axios from "axios";
import { NOTES_ENDPOINT } from "./GetBatchNotes";

const DeleteBatchNote = async ({ payload }) => {
  const data = new FormData();
  data.append("session", payload.session);
  data.append("id", payload.id);

  const res = await axios.post(
    NOTES_ENDPOINT + "admin-delete-batch-note.php",
    data,
    { headers: { "content-type": "multipart/form-data" } },
  );
  return res ? res.data : null;
};

export default DeleteBatchNote;
